import React from 'react';

interface SubmissionProps {
  isDark: boolean;
}

const Submission = ({ isDark }: SubmissionProps) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 text-gray-900 dark:text-white">
        This feature is not implemented yet, come later! 😉
      </h2>
      <p className="text-gray-700 dark:text-gray-300 text-sm sm:text-base md:text-lg max-w-xl">
        We're working on it. Please check back soon for updates!
      </p>
    </div>
  );
};

export default Submission;
